<template>
    <div class="bizcomp-assets box">
        <el-tabs v-model="activeType" class="tab">
            <el-tab-pane name="assets" label="资产总览">
                <my-assets ref="assets"></my-assets>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import myAssets from "@/components/financialmanagement/myAssets";
import commonApi from "@/api/common";
import urls from "@/api/urls";

export default {
    name: "AssetTotal",
    components: {
        myAssets
    },
    mixins: [mixin],
    data() {
        return {
            activeType: "assets", // tab类型
            downLoadUrl: "", // 下载资产证明url
            resetVisible: false,
            loginPwdType: "0",
            userOtherInfo: { specialflag: 0 },
            myPhaseDisplay: false // 控制盈亏查询入口是否显示
        };
    },
    watch: {
        activeType(val) {
            if (val == "assets") {
                this.$refs.assets.searchAssets();
            } else if (val == "combination") {
                this.$refs.comboAssets.getAssets();
            } else if (val == "collection") {
                this.$refs.collection.searchFund();
            }
        }
    },
    async created() {
        if (this.$route.query && this.$route.query.tab) {
            this.activeType = this.$route.query.tab;
            this.$router.replace({ path: this.$route.path, query: {} });
        }
        this.downLoadUrl =
            this.$util.fileUploadPath(urls.assetsPdf) + "?token=" + this.$cache.getSessionToken();

        this.userOtherInfo = this.$cache.getUserOtherInfo();
        if (!this.$util.getConfig().hideFunc) return;
        // 1：需要强制修改交易密码，3：需要强制修改交易密码和登录密码
        if (this.userOtherInfo.specialflag == "1" || this.userOtherInfo.specialflag == "3") {
            this.resetVisible = true;
            this.loginPwdType = 0;
        }
        // 2：需要强制修改登录密码;
        if (this.userOtherInfo.specialflag == "2") {
            this.resetVisible = true;
            this.loginPwdType = 1;
        }
    },
    mounted() {
        // this.myPhaseDisplay =
        //     this.$cache.getParamValue("business_module") &&
        //     this.$cache.getParamValue("business_module").bizenable["027"];
    },
    methods: {
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            if (this.loginPwdType == 0) {
                this.$router.push({ name: "changetpwd" });
            } else {
                this.$router.push({ name: "changelpwd" });
            }
        },
        tracesLog() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.acct_download_file,
                eventname: `下载文件`,
                content: JSON.stringify({ name: "资产证明", url: this.downLoadUrl })
            });
        }
    }
};
</script>

<style lang="scss">
.box {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: #f1f1f1;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .file-button {
        position: absolute;
        width: 100px;
        height: 40px;
        top: 15px;
        right: 25px;
        background: #f1f1f1;
        color: #666666;
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
    }
}
</style>
